import { render, staticRenderFns } from "./front-single-form-editor.vue?vue&type=template&id=cca49400&scoped=true"
import script from "./front-single-form-editor.vue?vue&type=script&lang=js"
export * from "./front-single-form-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca49400",
  null
  
)

export default component.exports